import { useState } from 'react';
import Button from './button';
import PopUp from '../../../components/Popup/Popup';
import { sendFormEmail } from '../../../lib/sendEmail';

const Input = ({ placeholder, onChange, value, label, id, type = 'text' }) => {
  return (
    <div>
      <label className="text-left mb-4 mx-2" htmlFor={id}>{label}</label>
      <br />
      <input
        id={id}
        name={id}
        type={type}
        className="border border-gray-300 rounded-md p-2 w-[90%] mb-4"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

const ContactForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    businessDesc: '',
    socialMedia: '',
  });

  const handleInputChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.value,
    });

    if (field === 'email') {
      setEmailError('');
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(formData.email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');

    try {
      await sendFormEmail('visibility', {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        businessDesc: formData.businessDesc,
        socialMedia: formData.socialMedia,
      });

      setShowModal(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        businessDesc: '',
        socialMedia: '',
      });
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitError('Something went wrong. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-10 bg-gradient-subtle" id="contact-form">
      <div className="px-4 max-w-5xl mx-auto">
        <form
          className="w-full max-w-lg min-w-0 mx-auto bg-white sm:p-6 p-4 rounded-lg shadow-[0_8px_24px_0_rgba(59,130,246,0.15)]"
          onSubmit={handleSubmit}
          aria-busy={isSubmitting}
        >
          <h2 className="text-3xl md:text-4xl text-center font-bold mb-4 text-foreground">
            Get Your Free Consultation
          </h2>
          <p className="text-lg text-muted-foreground text-center">
            Fill out the form below and let&apos;s discuss how we can grow your business
          </p>
          <br />
          <div className="px-[10%] mt-4">
            <Input
              id="visibility-name"
              label="Full Name"
              placeholder="Name"
              onChange={(e) => handleInputChange(e, 'name')}
              value={formData.name}
            />

            <Input
              id="visibility-email"
              label="Email Address"
              type="email"
              placeholder="Email"
              onChange={(e) => handleInputChange(e, 'email')}
              value={formData.email}
            />
            {emailError && <p className="error-text">{emailError}</p>}

            <Input
              id="visibility-phone"
              label="Phone Number"
              type="tel"
              placeholder="Phone"
              onChange={(e) => handleInputChange(e, 'phone')}
              value={formData.phone}
            />

            <label className="ml-2" htmlFor="visibility-business">Business Description</label>
            <br />
            <textarea
              id="visibility-business"
              name="visibility-business"
              placeholder="Brief description of your business"
              className="border border-gray-300 rounded-md p-2 w-[90%] !h-[100px] mb-4 resize-none"
              value={formData.businessDesc}
              onChange={(e) => handleInputChange(e, 'businessDesc')}
            />
            <br />
            <label className="ml-2" htmlFor="visibility-social">Social Media Handles</label>
            <br />
            <textarea
              id="visibility-social"
              name="visibility-social"
              placeholder="Social media handles if any"
              className="border border-gray-300 rounded-md p-2 w-[90%] !h-[100px] mb-4 resize-none"
              value={formData.socialMedia}
              onChange={(e) => handleInputChange(e, 'socialMedia')}
            />
            <br />
          </div>
          {submitError && <p className="error-text text-center">{submitError}</p>}
          <div className="flex justify-center">
            <Button text={isSubmitting ? 'Sending...' : 'Claim My Free consultation'} disabled={isSubmitting} />
          </div>
          <br />
        </form>

        <PopUp
          msg="Thanks for reaching out! We're excited"
          desc={
            <>
              To explore how our solutions can help you, visit{' '}
              <a
                href="https://www.belsoftsystems.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'blue',
                  textDecoration: 'underline',
                }}
              >
                www.belsoftsystems.com
              </a>{' '}
              to discover more about our services. One of our specialized agents will
              reach out to you soon to guide you on the next steps.
            </>
          }
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      </div>
    </section>
  );
};

export default ContactForm;
